import { combineReducers } from "redux";
import user from "./userReducer";
import permissions from "./permissionsReducer";

const rootReducer = combineReducers({
  user,
  permissions,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js